import { render } from "./trainingForm.vue?vue&type=template&id=7ce28aab"
import script from "./trainingForm.vue?vue&type=script&lang=js"
export * from "./trainingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__